import { getOffice } from './office'

export const isMac = () => navigator.vendor === 'Apple Computer, Inc.'
export const isWindows = () => !isMac()
export const isDesktop = (office = getOffice()) =>
  office.context.mailbox.diagnostics.hostName === 'Outlook'
export const isWeb = (office = getOffice()) =>
  office.context.mailbox.diagnostics.hostName === 'OutlookWebApp'
export const isDesktopMac = (office = getOffice()) => isDesktop(office) && isMac()
export const isDesktopWindows = (office = getOffice()) => isDesktop(office) && isWindows()
